import { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import gsap from 'gsap'
import { siInstagram, siFacebook, siYoutube } from 'simple-icons'
import './Navbar.css'

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/philosophy', label: 'Philosophy' },
  { path: '/team', label: 'Our Team' },
  // { path: '/menu', label: 'Flavours' },
  { path: '/stores', label: 'Our Stores' },
  { path: '/careers', label: "We're Hiring" },
  { path: '/franchise', label: 'Franchise' },
  { path: '/contact', label: 'Contact' },
]

const renderMobileSocialIcon = (iconType) => {
  switch(iconType) {
    case 'instagram':
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <path fill="#ffffff" d={siInstagram.path} />
        </svg>
      )
    case 'facebook':
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <path fill="#ffffff" d={siFacebook.path} />
        </svg>
      )
    case 'youtube':
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <path fill="#ffffff" d={siYoutube.path} />
        </svg>
      )
    default: return null
  }
}

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const location = useLocation()
  const navRef = useRef(null)
  const mobileMenuRef = useRef(null)
  const timelineRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    // Close mobile menu on route change
    setIsMobileOpen(false)
  }, [location])

  useEffect(() => {
    // Animate navbar on load
    gsap.fromTo(
      navRef.current,
      { y: -100, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', delay: 0.5 }
    )
  }, [])

  useEffect(() => {
    // Mobile menu animation
    if (mobileMenuRef.current) {
      if (isMobileOpen) {
        document.body.style.overflow = 'hidden'
        
        timelineRef.current = gsap.timeline()
        timelineRef.current
          .to(mobileMenuRef.current, {
            clipPath: 'circle(150% at calc(100% - 40px) 40px)',
            duration: 0.8,
            ease: 'power4.inOut'
          })
          .fromTo(
            '.mobile-nav-link',
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.08, duration: 0.5, ease: 'power3.out' },
            '-=0.3'
          )
      } else {
        document.body.style.overflow = ''
        
        gsap.to(mobileMenuRef.current, {
          clipPath: 'circle(0% at calc(100% - 40px) 40px)',
          duration: 0.6,
          ease: 'power4.inOut'
        })
      }
    }
    
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMobileOpen])

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''}`} ref={navRef}>
      <div className="navbar-container">
        <Link to="/" className="logo">
          <img 
            src="/logo.png" 
            alt="BIGGUYS Logo" 
            className="logo-image" 
          />
        </Link>

        <nav className="nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              <span className="nav-link-text">{link.label}</span>
              <span className="nav-link-underline"></span>
            </Link>
          ))}
        </nav>

        <button 
          className={`hamburger ${isMobileOpen ? 'open' : ''}`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className="mobile-menu" ref={mobileMenuRef}>
        <nav className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setIsMobileOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        
        <div className="mobile-menu-footer">
          <div className="mobile-social-links">
            <a href="https://www.instagram.com/bigguysindia/" target="_blank" rel="noopener noreferrer">
              {renderMobileSocialIcon('instagram')}
              {/* <span>Instagram</span> */}
            </a>
            <a href="https://www.facebook.com/profile.php?id=61556784862328" target="_blank" rel="noopener noreferrer">
              {renderMobileSocialIcon('facebook')}
              {/* <span>Facebook</span> */}
            </a>
            <a href="https://www.youtube.com/@BigguysIndia" target="_blank" rel="noopener noreferrer">
              {renderMobileSocialIcon('youtube')}
              {/* <span>YouTube</span> */}
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}
